import React from "react";
import { Redirect } from "react-router-dom";
import history from "../navigators/history";
import config from "../config";

const navigateWithPreAction = (path, params) => {
  // do any pre action here
  history.push({
    pathname: path,
    state: { ...params },
  });
};

const navigateReplaceWithPreAction = (path, params) => {
  // do any pre action here
  history.replace({
    pathname: path,
    state: { ...params },
  });
};

const decidePreExperimentPage = (path) => {};

export const openLogin = (params) => {
  navigateWithPreAction(config.routes.login, params);
};

export const openName = (params) => {
  navigateWithPreAction(config.routes.name, params);
};

export const openEmail = (params) => {
  navigateWithPreAction(config.routes.email, params);
};

export const openDob = (params) => {
  navigateWithPreAction(config.routes.dob, params);
};

export const openAddress = (params) => {
  navigateWithPreAction(config.routes.address, params);
};

export const openAnnualIncome = (params) => {
  navigateWithPreAction(config.routes.annualIncome, params);
};

export const openLiquidAssets = (params) => {
  navigateWithPreAction(config.routes.liquidAssets, params);
};

export const openCitizenship = (params) => {
  navigateWithPreAction(config.routes.citizenship, params);
};

export const openSsn = (params) => {
  navigateWithPreAction(config.routes.ssn, params);
};

export const openKyc2 = (params) => {
  navigateWithPreAction(config.routes.kyc2, params);
};

export const openKyc3 = (params) => {
  navigateWithPreAction(config.routes.kyc3, params);
};

export const openRiskQuestionnaire = (params) => {
  navigateWithPreAction(config.routes.riskQuestionnaire, params);
};

export const openRiskRecommendation = (params) => {
  navigateWithPreAction(config.routes.riskRecommendation, params);
};

export const openAccountFundingSource = (params) => {
  navigateWithPreAction(config.routes.accountFundingSource, params);
};

export const openBankingInfo = (params) => {
  navigateWithPreAction(config.routes.bankinginfo, params);
};

export const openDisclosures = (params) => {
  navigateWithPreAction(config.routes.disclosures, params);
};

export const openAccountOpenWait = (params) => {
  navigateWithPreAction(config.routes.accountOpenWait, params);
};

export const openKycFail = (params) => {
  navigateWithPreAction(config.routes.kycFail, params);
};

export const openAccountOpenSuccess = (params) => {
  navigateWithPreAction(config.routes.accountOpenSuccess, params);
};

export const openBuyWait = (params) => {
  navigateWithPreAction(config.routes.buyWait, params);
};

export const openBuySuccess = (params) => {
  navigateWithPreAction(config.routes.buySuccess, params);
};

export const openFundingFail = (params) => {
  navigateWithPreAction(config.routes.fundingFail, params);
};

export const openShowHoldings = (params) => {
  navigateWithPreAction(config.routes.showHoldings, params);
};

export const open500ErrorPage = (params) => {
  navigateWithPreAction(config.routes.networkError, params);
};

export const goToPage = (path, params) => {
  navigateWithPreAction(path, params);
};

export const goBack = async () => {
  let prevPath = history.location.pathname;
  let count = 0;
  const unlisten = history.listen((location) => {
    let nextPath = location.pathname;
    if (prevPath == nextPath) {
      if (count >= 1) {
        history.goBack();
      }
      count += 1;
    }
    if (prevPath != nextPath) unlisten();
  });
  history.goBack();
};
